import { curatedBaseApi } from "./baseApi";
import { getAllFaqCategoriesQs, getAllFaqsQs, getFaqCategoryInfo, getFaqFromCategoryQs, getPopularArticlesQs, getSpecificFaqQs } from "./faqQsFilters";

const faqCategoriesPath = "/faq-categories"
const faqsPath = "/faqs"
const faqPopularArticlesPath = "/faq-popular-article"

export const faqApi = curatedBaseApi.injectEndpoints({
    endpoints: (build) => ({
        // gets all faq categories
        getAllFaqCategories: build.query({
            query: () => {
                return {
                    url: `${faqCategoriesPath}?${getAllFaqCategoriesQs}`,
                }
            },
            transformResponse: (response) => response.data
        }),
        // Gets all FAQs
        getAllFaqs: build.query({
            query: (cipVersionType) => {
                return {
                    url: `${faqsPath}?${getAllFaqsQs(cipVersionType)}`,
                }
            },
            transformResponse: (response) => response.data
        }),
        // Gets faqs by category
        getFaqsFromCategory: build.query({
            query: ({ category, cipVersionType }) => {
                return {
                    url: `${faqsPath}?${getFaqFromCategoryQs(category, cipVersionType)}`,
                }
            },
            transformResponse: (response) => response.data
        }),
        getSpecificFaq: build.query({
            query: ({ categorySlug, questionSlug }) => {
                return {
                    url: `${faqsPath}?${getSpecificFaqQs(categorySlug, questionSlug)}`,
                }
            },
            transformResponse: response => response.data
        }),
        getFaqCategoryIcon: build.query({
            query: (categorySlug) => {
                return {
                    url: `${faqCategoriesPath}?${getFaqCategoryInfo(categorySlug)}`,
                }
            },
            transformResponse: response => response.data
        }),
        getPopularArticles: build.query({
            query: () => {
                return {
                    url: `${faqPopularArticlesPath}?${getPopularArticlesQs}`,
                }
            },
            transformResponse: response => response.data
        }),
        


    }),
    overrideExisting: false
})

export const {
    useGetAllFaqCategoriesQuery,
    useGetAllFaqsQuery,
    useGetFaqsFromCategoryQuery,
    useGetSpecificFaqQuery,
    useGetFaqCategoryIconQuery,
    useGetPopularArticlesQuery,
} = faqApi